module.exports = __webpack_public_path__ + "Server-Unknown.Ssh.de70ef1a1f63f644a3511fefab70141c.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Unknown.Ssh.png
// module id = 1270
// module chunks = 1